// export const CONTENT_CHART_OPTIONS = {
//     chart: {
//         type: 'radialBar',
//     },
//     colors: ['#8C3F7D', '#DB97D2'],
//     plotOptions: {
//         radialBar: {
//             startAngle: -90,
//             endAngle: 90,
//             track: {
//                 background: '#F9FAFB',
//                 startAngle: -90,
//                 endAngle: 90,
//             },
//             dataLabels: {
//                 show: true,
//                 name: {
//                     show: true,
//                     fontSize: '12px',
//                     lineHeight: '18px',
//                     fontWeight: 500,
//                     color: '#667085',
//                 },
//                 value: {
//                     show: true,
//                     fontSize: '18px',
//                     lineHeight: '28px',
//                     fontWeight: 500,
//                     color: '#101828',
//                 },
//                 total: {
//                     show: false,
//                 },
//             },
//         },
//     },
//     stroke: {
//         lineCap: 'butt',
//     },
//     labels: ['Branded', 'Unbranded'],
// };

// export const CONTENT_CHART_SERIES = [58.2, 41.8];

// export const TOPIC_CHART_OPTIONS = {
//     chart: {
//         height: 72,
//         type: 'donut',
//     },

//     stroke: {
//         show: false,
//     },
//     colors: ['#F3DBF1', '#8C3F7D', '#AD509E', '#C76EBA', '#DB97D2'],
//     labels: ['Efficacy', 'Safety', 'Dosing', 'MOA', 'Disease state'],
//     legend: {
//         position: 'right',
//     },
//     dataLabels: {
//         enabled: false,
//     },
// };

// export const TOPIC_CHART_SERIES = [44, 55, 13, 33];

// export const HIGHCHART_CONTENT_CHART_OPTIONS = {
//     chart: {
//         type: 'pie',
//         backgroundColor: null,
//         plotBorderWidth: 0,
//         plotShadow: false,
//     },
//     title: {
//         text: null,
//     },
//     exporting: {
//         enabled: false
//     },
//     credits: {
//         enabled: false
//     },
//     plotOptions: {
//         pie: {
//             startAngle: -90,
//             endAngle: 90,
//             center: ['50%', '75%'],
//             dataLabels: {
//                 enabled: true,
//                 distance: -100,
//                 y: -5,
//                 format: '<b>{point.name}</b> <br /> {point.y}%',

//             },
//             point: {
//                 events: {
//                     legendItemClick: function () {
//                         return false; // Disable clicking on legend items
//                     },
//                 },
//             },
//         },
//     },
//     series: [
//         {

//             data: [
//                 {
//                     name: 'Virtual',
//                     y: 58.2,
//                     color: '#8C3F7D',
//                 },
//                 {
//                     name: 'In Person',
//                     y: 41.8,
//                     color: '#DB97D2',
//                 },
//             ],
//             size: '100%',
//             innerSize: '75%',
//             showInLegend: false,
//             // dataLabels: {
//             //     enabled: true,
//             //     format: '<b>{point.name}</b>: {point.y}%',
//             // },
//         },
//     ],
// };

// export const SEMI_DONUT_CHART_SERIES = [58.2, 41.8];

// export const SEMI_DONUT_CHART_OPTIONS = {
//     chart: {
//         type: 'donut',
//         height: 72,
//     },
//     stroke: {
//         show: false,
//     },
//     colors: ['#8C3F7D', '#DB97D2'],
//     labels: ['Branded', 'Unbranded'],
//     legend: {
//         position: 'right',
//     },
//     dataLabels: {
//         enabled: false,
//     },

//     plotOptions: {
//         pie: {
//             startAngle: -90,
//             endAngle: 90,
//             offsetY: 10,
//         },
//     },
//     grid: {
//         padding: {
//             // bottom: -150,
//         },
//     },
//     responsive: [{
//         breakpoint: 1400,
//         options: {
//             grid: {
//                 padding: {
//                     // bottom: -100,
//                 },
//             },
//         },
//     }]
// };

export const CONTENT_TYPE_CHART_OPTIONS = {
    colors: ['#8C3F7D', '#DB97D2'],
    lang: {
        noData: 'No data to display',
    },
    noData: {
        style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: '#303030',
        },
    },
    chart: {
        type: 'pie',
        backgroundColor: null,
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        height: 150,
        
        spacingTop: 0,
        spacingBottom: 0,
        spacingLeft: 0,
        spacingRight: 0,
    },
    // accessibility: {
    //     point: {
    //         valueSuffix: '%'
    //     }
    // },
    title: {
        text: null,
    },
    subtitle: {
        text: null,
    },
    exporting: {
        enabled: false,
    },
    credits: {
        enabled: false,
    },
    // tooltip: {
    //     pointFormat: '{series.name}: <b>{point.percentage:.0f}%</b>'
    // },
    tooltip: {
        useHTML: true,
        backgroundColor: '#000',
        style: {
            color: '#fff',
            fontSize: '10px',
        },
        formatter: function() {
            return `<b>${this.key}</b>: ${this.y}% <br>`;
        },
    },
    legend: {
        margin:4,
        align: 'right',
        layout: 'vertical',
        verticalAlign: 'top',
        x: 0,
        y: 10,
        itemStyle: {
            color: '#667085',
            fontWeight: 400,
            fontSize: '12px',
        },
    },
    plotOptions: {
        pie: {
            shadow: false,
            borderWidth: 0,
            allowPointSelect: false,
            size: '100%',
            dataLabels: { enabled: false },
        },
    },
    series: [
        {
            name: 'Content Type',
            data: [
                {
                    name: 'Branded',
                    y: 58.2,
                },
                {
                    name: 'Unbranded',
                    y: 41.8,
                },
            ],
            size: "60%",
            innerSize: "70%",
            showInLegend: true,
            // enableMouseTracking: false,
            borderRadius: 0,
            // dataLabels: {
                // enabled: false,
                // crop: false,
                // distance: '-10%',
                // style: {
                //     fontWeight: 'bold',
                //     fontSize: '16px'
                // },
                // connectorWidth: 0
            // },
        },
    ],
};



export const TOPIC_CHART_OPTIONS = {
    colors: ["#FCCEEE", "#E9BEE3", "#DB97D2", "#C76EBA", "#F3DBF1","#AD509E", "#8C3F7D", "#733567","#FCE7F6", "#602F56", "#3D1535"],
    lang: {
        noData: 'No data to display',
    },
    noData: {
        style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: '#303030',
        },
    },
    chart: {
        type: 'pie',
        backgroundColor: null,
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        height: 150,
        
        spacingTop: 0,
        spacingBottom: 0,
        spacingLeft: 0,
        spacingRight: 0,
    },
    // accessibility: {
    //     point: {
    //         valueSuffix: '%'
    //     }
    // },
    title: {
        text: null,
    },
    subtitle: {
        text: null,
    },
    exporting: {
        enabled: false,
    },
    credits: {
        enabled: false,
    },
    // tooltip: {
    //     pointFormat: '{series.name}: <b>{point.percentage:.0f}%</b>'
    // },
    tooltip: {
        useHTML: true,
        backgroundColor: '#000',
        style: {
            color: '#fff',
            fontSize: '10px',
        },
        formatter: function() {
            return `<b>${this.key}</b>: ${this.y}% <br>`;
        },
    },
    legend: {
        margin:4,
        align: 'right',
        layout: 'vertical',
        verticalAlign: 'top',
        x: 0,
        y: 10,
        itemStyle: {
            color: '#667085',
            fontWeight: 400,
            fontSize: '12px',
        },
    },
    plotOptions: {
        pie: {
            shadow: false,
            borderWidth: 0,
            allowPointSelect: false,
            size: '100%',
            dataLabels: { enabled: false },
        },
    },
    series: [
        {
            name: 'Topic',
            data: [
                {
                    name: 'Efficacy',
                    y: 20,
                },
                {
                    name: 'Safety',
                    y: 20,
                },
                {
                    name: 'Dosing',
                    y: 35,
                },
                {
                    name: 'MOA',
                    y: 13,
                },
                {
                    name: 'Disease state',
                    y: 12,
                },
            ],
            size: "60%",
            innerSize: "70%",
            showInLegend: true,
            // enableMouseTracking: false,
            borderRadius: 0,
            // dataLabels: {
                // enabled: false,
                // crop: false,
                // distance: '-10%',
                // style: {
                //     fontWeight: 'bold',
                //     fontSize: '16px'
                // },
                // connectorWidth: 0
            // },
        },
    ],
};
